import type { FaqItem } from "./types";

export const mainPageFaq: FaqItem[] = [
  {
    id: "main-ppf-basic",
    question: "Mis on PPF (Paint Protection Film) kaitsekile?",
    answer:
      "PPF on läbipaistev polüuretaanist kaitsekile, mis paigaldatakse auto värvitud pindadele. See kaitseb kivitäkete, kriimustuste ja UV-kiirguse eest, säilitades auto originaalse värvi ja läike.",
  },
  {
    id: "main-ppf-ceramic-difference",
    question: "Mis vahe on PPF-il ja keraamilisel kaitsel?",
    answer:
      "PPF kaitseb mehaaniliste kahjustuste eest, näiteks kivitäkked ja kriimustused. Keraamiline kaitse teeb pinna vetthülgavaks ja lihtsustab hooldust, kuid ei paku sama kaitset löökide eest.",
  },
  {
    id: "main-ceramic-lifespan",
    question: "Kui kaua keraamiline kaitse vastu peab?",
    answer:
      "Õige hoolduse korral kestab kvaliteetne keraamiline kate tavaliselt 2–4 aastat. Pikaajalise kaitse saavutamiseks on oluline kasutada sobivaid hooldusvahendeid.",
  },
  {
    id: "main-ppf-protect",
    question: "Kas PPF kaitseb auto värvi kahjustuste eest?",
    answer:
      "Jah, paigaldatud PPF imeb lööke ja kriimustusi, mis muidu kahjustaksid värvi. See aitab hoida auto pinna algupärast seisukorda ja edasimüügi väärtust.",
  },
  {
    id: "main-tinting-legal",
    question: "Kas klaaside toonimine on Eestis lubatud?",
    answer:
      "Jah, klaaside toonimine on lubatud, kuid esiklaasil ja esiuste klaasidel peab valguse läbilaskvus olema vähemalt 75%. Meie toonimine vastab kohalikele nõuetele.",
  },
  {
    id: "main-response-time",
    question: "Kui kiiresti vastate päringule?",
    answer:
      "Vastame tavaliselt 24 tunni jooksul. Täpsema hinnapakkumise saamiseks võite saata meile auto mudelit ja soovitud teenuse kohta lühikese kirjelduse.",
  },
  {
    id: "main-ceramic-dirt",
    question: "Kas keraamiline kaitse aitab auto pinda puhastada?",
    answer:
      "Jah, keraamiline kate muudab pinna hüdrofoobseks ja takistab mustuse ning veepiisade kinnitumist. See teeb auto pesemise lihtsamaks ja aitab säilitada läiget.",
  },
  {
    id: "main-tinting-heat",
    question: "Kas toonimine vähendab salongi kuumenemist?",
    answer:
      "Jah, kvaliteetne toonkile vähendab päikese soojuskoormust ja parandab salongi mugavust, eriti suvekuudel.",
  },
];
